export const sectionType = {
  SCENE: 'scene',
  THEME: 'theme',
  SOUNDTRACK: 'soundtrack',
  HEADER: 'header',
};

/**
 * Verify string ends with image extension
 * Note: this does not check if the string is a valid URL
 * @param {string} str
 * @return boolean
 */
export function isImageUrl(str) {
  return str && str.match(/\.(jpeg|jpg|gif|png)$/) !== null;
}

/**
 * DELETE MOCK DATA WHEN NO LONGER NEEDED
 */
export const mockData = {
  soundtracks: [
    {
      key: 'soundtrack1',
      image: 'linear-gradient(-151deg,#9adbe8,#0056ff)',
      audio: {
        src: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3',
        type: 'audio/mp3',
      },
    },
    {
      key: 'soundtrack2',
      image: 'linear-gradient(38deg,#ff007e,#ff5d70)',
      audio: {
        src: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-2.mp3',
        type: 'audio/mp3',
      },
    },
    {
      key: 'soundtrack3',
      image: 'linear-gradient(-142deg,#f9d423,#ff9600)',
      audio: {
        src: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-3.mp3',
        type: 'audio/mp3',
      },
    },
    {
      key: 'soundtrack4',
      image: 'linear-gradient(-151deg,#ce64fd,#8d2df0)',
      audio: {
        src: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-4.mp3',
        type: 'audio/mp3',
      },
    },
    {
      key: 'soundtrack5',
      image: 'linear-gradient(-151deg,#38f9d7,#43e97b)',
      audio: {
        src: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-5.mp3',
        type: 'audio/mp3',
      },
    },
    {
      key: 'soundtrack6',
      image: 'linear-gradient(-48deg,#e0ff63,#1b8f00)',
      audio: {
        src: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1000.mp3',
        type: 'audio/mp3',
      },
    },
  ],
  colors: [
    {
      key: 'color1',
      image: 'linear-gradient(-151deg,#00c8ff,#0056ff)',
    },
    {
      key: 'color2',
      image: 'linear-gradient(-151deg,#ff4f02,#ffcd1e)',
    },
    {
      key: 'color3',
      image: 'linear-gradient(-151deg,#e0ff63,#22b200)',
    },
    {
      key: 'color4',
      image: 'linear-gradient(-151deg,#ff007e,#ff5d70)',
    },
    {
      key: 'color5',
      image: 'linear-gradient(-151deg,#2af598,#009efd)',
    },
    {
      key: 'color6',
      image: 'linear-gradient(-151deg,#ce64fd,#8d2df0)',
    },
  ],
};
